import { createAction, props } from '@ngrx/store';
import { TooltipMessage } from '@/shared/flow-states-tooltip/flow-states-tooltip.interface';

export const AddNewTooltip = createAction(
  '[flow-states-tooltip] Add New tooltip',
  props<TooltipMessage>(),
);

export const RemoveTooltip = createAction(
  '[flow-states-tooltip] Remove tooltip',
  props<{id: number}>(),
);

export const HideTooltip = createAction(
  '[flow-states-tooltip] Hide tooltip',
  props<{id: number}>(),
);
